import { ProgressPage } from "design-library";

import { ErrorPage } from "components";
import { useTranslate } from "i18n";

import { useBindCredential } from "./useBindCredential";

export const BindCredentialScreen = () => {
  const { t } = useTranslate();

  const { isError, isInvalidRequest } = useBindCredential(window.location.href);

  if (isInvalidRequest) {
    return <ErrorPage />;
  }
  if (isError) {
    return (
      <ErrorPage showRetryInstructions message={t("couldNotSetupCredential")} />
    );
  }
  return <ProgressPage message={t("settingUpYourCredential")} />;
};
